import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=4c45119e&scoped=true&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadComponent.vue?vue&type=style&index=0&id=4c45119e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c45119e",
  null
  
)

export default component.exports